import React from 'react';
import EntityProfile from 'components/EntityPage/EntityProfile';
import userSchema from '../schema';

const UserProfile = ({ entity, entityInfos, onActivityLogSubmitHandler }) => {
  return (
    <EntityProfile
      entity={entity}
      entityInfos={entityInfos}
      entitySchema={userSchema}
      onActivityLogSubmitHandler={onActivityLogSubmitHandler}
    />
  );
};

// UserProfile.propTypes = {
//   entity: PropTypes.object.isRequired(),
// };

export default UserProfile;
